import React from "react";
import "./TestimonialsNew.css";

const testimonials = [
  {
    name: "Dhruv Agarwal",
    position: "Co-Founder @ Proton Labs",
    text: "Brandly is more than just a LinkedIn tool; it's a game-changer for content creation. Its user-friendly interface makes it easy to navigate, even for someone like me who isn’t tech-savvy.",
    profilePhoto: require("../../assets/TestimonialPhoto1.png"),
  },
  {
    name: "Talia Taylor",
    position: "Co-Founder @ Beta Labs",
    text: "I wasn’t sure at first, but Brandly delivers. It’s creative, efficient, and makes LinkedIn content so much more manageable.",
    profilePhoto: require("../../assets/TestimonialPhoto2.png"),
  },
  {
    name: "John Doe",
    position: "CEO @ Alpha Inc.",
    text: "Brandly made creating posts so much easier. The suggestions feel tailored, and I’ve saved a lot of time using it.",
    profilePhoto: require("../../assets/TestimonialPhoto3.png"),
  },
];

const arrowImage = require("../../assets/brandlyuparrow.png")

const TestimonialsNew = () => {
  return (
    <div className="testimonials-container">
      <h1 className="trusted-heading">
        Trusted <span className="black-trusted-heading">by Many</span>
      </h1>
      <div className="outer-box">
        <div className="inner-box">
          <div className="left-section">
            <h2>
              Why Creators <br />
              Choose Brandly<img
                src={arrowImage}
                alt="Up Arrow"
                className="brandly-up-arrow"
              />
            </h2>


          </div>
          <div className="right-section">
            <div className="carousel">
              {/* Map testimonials twice for seamless looping */}
              {[...testimonials, ...testimonials].map((testimonial, index) => (
                <div className="testimonial-card" key={index}>
                  <p className="testimonial-text">“{testimonial.text}”</p>
                  <div className="author-info">
                    <img
                      src={testimonial.profilePhoto}
                      alt={testimonial.name}
                      className="profile-photo"
                    />
                    <div>
                      <p className="author-name">{testimonial.name}</p>
                      <p className="author-position">{testimonial.position}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsNew;
